import ErrorMessage from 'components/common/ErrorMessage';
import { AuthLayout } from 'layouts/AuthLayout';
import React, { memo, useCallback, useState } from 'react';
import toast from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import { Link, Navigate, useNavigate, useSearchParams } from 'react-router-dom';
import { resetPassword } from 'slices/userSlice';
import { userSelector } from 'slices/userSlice';
import { setError } from 'slices/userSlice';

const Footer = memo(() => (
    <div className='center_wrapper'>
        <p className="para3">Don't have Interpreter Account? <Link to="/register">Let's Create One!</Link></p>
    </div>
))

function ResetPassword() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { error } = useSelector(userSelector);
    const [searchParams] = useSearchParams();

    const token = searchParams.get('token');
    const email = searchParams.get('email');

    const [formValues, setFormValues] = useState({
        password: '',
        password_confirmation: '',
    });
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const handleChange = useCallback((e) => {
        setFormValues(prev => ({ ...prev, [e.target.name]: e.target.value }));
    }, []);

    const submitCallback = (status, message) => {
        if (status) {
            toast.success('Password reset successfully. Please log in.', { className: "successToast", duration: 5000 });
            navigate('/login');
        } else {
            toast.error(message, { className: "errorToast" });
        }
    };

    const handleSubmit = useCallback((e) => {
        e.preventDefault();
        dispatch(setError({}));
        dispatch(resetPassword({ ...formValues, token, email }, submitCallback));
    }, [formValues, token, email]);

    // No token or email in URL — not reached via email link
    if (!token || !email) {
        return <Navigate to="/forgot-password" replace />;
    }

    return (
        <AuthLayout
            heading="Set New Password"
            title=""
            footer={<Footer />}
        >
            <form className='auth_form' action='' onSubmit={handleSubmit}>
                <div className="form-group">
                    <div className="form-group">
                        <div className="row-input">
                            <img src="/images/lock.png" alt="" />
                            <input
                                type={showPassword ? "text" : "password"}
                                name="password"
                                id="password"
                                autoComplete="off"
                                onChange={handleChange}
                                placeholder="Enter a new password"
                                required
                            />
                            <img
                                src={showPassword ? "/images/eye-close.png" : "/images/eye.png"}
                                alt=""
                                onClick={() => setShowPassword(p => !p)}
                                style={{ cursor: 'pointer' }}
                            />
                        </div>
                    </div>
                    <div className="form-group">
                        <div className="row-input">
                            <img src="/images/lock.png" alt="" />
                            <input
                                type={showConfirmPassword ? "text" : "password"}
                                name="password_confirmation"
                                id="password_confirmation"
                                autoComplete="off"
                                placeholder="Confirm new password"
                                onChange={handleChange}
                                required
                            />
                            <img
                                src={showConfirmPassword ? "/images/eye-close.png" : "/images/eye.png"}
                                alt=""
                                onClick={() => setShowConfirmPassword(p => !p)}
                                style={{ cursor: 'pointer' }}
                            />
                        </div>
                    </div>
                    {error?.errors?.password?.map((err, i) => (
                        <ErrorMessage key={i} text={err} />
                    ))}
                </div>
                <p className="para2">
                    <Link to="/login">
                        <i className="fa-solid fa-chevron-left me-2"></i>
                        Back to Login
                    </Link>
                </p>
                <button type="submit" className="btn_auth">Reset Password</button>
            </form>
        </AuthLayout>
    );
}

export default ResetPassword;
